"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCacheOnCreatePreset = exports.CREATE_PRESET = exports.EDIT_PRESET = exports.updateCacheOnDuplicatePreset = exports.DUPLICATE_PRESET = exports.updateCacheOnDeletePrest = exports.DELETE_PRESET = void 0;
const client_1 = require("@apollo/client");
const __1 = require("../..");
const restricted_1 = require("../../query/restricted");
exports.DELETE_PRESET = (0, client_1.gql) `
  mutation DeletePreset($presetId: Int!) {
    restricted {
      deletePreset(presetId: $presetId)
    }
  }
`;
const updateCacheOnDeletePrest = () => (cache, result, options) => {
    const { deletePreset } = result?.data?.restricted || {};
    const { variables } = options || {};
    const { presetId } = variables || {};
    if (deletePreset && presetId) {
        const prevData = cache.readQuery({
            variables: { order: __1.ESortOrder.DESC },
            query: restricted_1.PRESETS,
        });
        if (prevData) {
            const { presets } = prevData.restricted || {};
            const removedPresetIndex = presets.findIndex(({ id }) => Number(id) === Number(presetId));
            if (removedPresetIndex >= 0) {
                const updatedPresets = [
                    ...presets.slice(0, removedPresetIndex),
                    ...presets.slice(removedPresetIndex + 1),
                ];
                cache.writeQuery({
                    query: restricted_1.PRESETS,
                    variables: { order: __1.ESortOrder.DESC },
                    data: {
                        ...prevData,
                        restricted: {
                            ...prevData.restricted,
                            presets: [...updatedPresets],
                        },
                    },
                });
            }
        }
    }
};
exports.updateCacheOnDeletePrest = updateCacheOnDeletePrest;
exports.DUPLICATE_PRESET = (0, client_1.gql) `
  mutation DuplicatePreset($presetId: Int!) {
    restricted {
      duplicatePreset(presetId: $presetId) {
        id
        createdAt
        updatedAt
        name
        likes
        entitlementId
        entitlement {
          id
          name
        }
        correctQuestions
        incorrectQuestions
        completedQuestions
        totalQuestions
        yellowCards
        greenCards
        redCards
        completedCards
        totalCards
        userId
        concepts {
          id
          name
          topicId
        }
      }
    }
  }
`;
const updateCacheOnDuplicatePreset = () => (cache, result) => {
    const { duplicatePreset } = result?.data?.restricted || {};
    if (duplicatePreset) {
        const prevData = cache.readQuery({
            variables: { order: __1.ESortOrder.DESC },
            query: restricted_1.PRESETS,
        });
        if (prevData) {
            const { presets } = prevData.restricted || {};
            cache.writeQuery({
                query: restricted_1.PRESETS,
                variables: { order: __1.ESortOrder.DESC },
                data: {
                    ...prevData,
                    restricted: {
                        ...prevData.restricted,
                        presets: [{ ...duplicatePreset }, ...presets],
                    },
                },
            });
        }
    }
};
exports.updateCacheOnDuplicatePreset = updateCacheOnDuplicatePreset;
exports.EDIT_PRESET = (0, client_1.gql) `
  mutation EditPreset($presetId: Int!, $data: EditPresetInput!) {
    restricted {
      editPreset(presetId: $presetId, data: $data) {
        id
        createdAt
        updatedAt
        name
        likes
        entitlementId
        entitlement {
          id
          name
        }
        correctQuestions
        incorrectQuestions
        completedQuestions
        totalQuestions
        yellowCards
        greenCards
        redCards
        completedCards
        totalCards
        userId
        concepts {
          id
          name
          topicId
        }
      }
    }
  }
`;
exports.CREATE_PRESET = (0, client_1.gql) `
  mutation CreatePreset($data: CreatePresetInput!) {
    restricted {
      createPreset(data: $data) {
        id
        createdAt
        updatedAt
        name
        likes
        entitlementId
        entitlement {
          id
          name
        }
        correctQuestions
        incorrectQuestions
        completedQuestions
        totalQuestions
        yellowCards
        greenCards
        redCards
        completedCards
        totalCards
        userId
        concepts {
          id
          name
          topicId
        }
      }
    }
  }
`;
const updateCacheOnCreatePreset = (cache, result) => {
    const { createPreset } = result?.data?.restricted || {};
    if (createPreset) {
        const prevData = cache.readQuery({
            variables: { order: __1.ESortOrder.DESC },
            query: restricted_1.PRESETS,
        });
        if (prevData) {
            const { presets } = prevData.restricted || {};
            cache.writeQuery({
                query: restricted_1.PRESETS,
                variables: { order: __1.ESortOrder.DESC },
                data: {
                    ...prevData,
                    restricted: {
                        ...prevData.restricted,
                        presets: [{ ...createPreset }, ...presets],
                    },
                },
            });
        }
        else {
            cache.writeQuery({
                query: restricted_1.PRESETS,
                variables: {},
                data: {
                    restricted: {
                        __typename: 'RestrictedQuery',
                        presets: [{ ...createPreset }],
                    },
                },
            });
        }
    }
};
exports.updateCacheOnCreatePreset = updateCacheOnCreatePreset;
